import { Typography } from "@pmag/ui-components";
import { AvailabilityStatusMessage } from "@src/pages/subGroupDetail/subgroupDetailsListSection/availabilityStatusMessage/AvailabilityStatusMessage";
import { type SPFAvailabilityStatus } from "@src/utils/events";
import { type FunctionComponent } from "react";

import { Dot, Root } from "./AvailabilityStatus.styles";
import { getAvailabilityStatusChipColor } from "./getChipColor";

export interface AvailabilityStatusTooltipProps {
    availabilityStatus: SPFAvailabilityStatus;
    customText?: string;
}

export const AvailabilityStatus: FunctionComponent<AvailabilityStatusTooltipProps> = ({ availabilityStatus, customText }) => (
    <Root>
        <Dot color={getAvailabilityStatusChipColor(availabilityStatus)} />

        {customText ? (
            <Typography variant="label-01">{customText}</Typography>
        ) : (
            <AvailabilityStatusMessage availabilityStatus={availabilityStatus} />
        )}
    </Root>
);
